import React, { useCallback, useEffect, useState } from 'react';
import ModalBlank from './ModalBlank';
import CloseIcon from '../icons/CloseIcon';
import Input from './Input';

export const LinkModal = ({ modalOpen, setModalOpen, textValue = '', urlValue = '', formatLink }) => {
    const [text, setText] = useState(textValue || '');
    const [url, setUrl] = useState(urlValue || '');
    const [isValidUrl, setIsValidUrl] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (modalOpen) {
            setText(textValue || "");
            setUrl(urlValue || "");
        }
    }, [modalOpen, textValue, urlValue]);

    const onChangeUrl = useCallback((value) => {
        setUrl(value);
        setError('');
        setIsValidUrl(true);
    }, []);

    const handleDoneClick = (e) => {
        e.stopPropagation();
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
        const isValid = urlRegex.test(url);
        setIsValidUrl(isValid);
        setError(isValid ? '' : 'Invalid URL');
        if (isValid) {
            formatLink(text, url);
            setModalOpen(false);
        }
    };

    return (
        <ModalBlank modalOpen={modalOpen} setModalOpen={setModalOpen}>
            <button
                type="button"
                className="w-6 h-6 hidden md:flex items-center justify-center shadow-[1px_1px_3px_0px_rgba(7,54,97,0.06)] dark:shadow-[2px_4px_24px_0_rgba(4,13,22,0.30)] text-[#A4AAAC] dark:text-[#D4DCE2] bg-white dark:bg-[#1F2936] rounded-[6px] transition hover:opacity-75 absolute top-4 right-4"
                onClick={() => setModalOpen(false)}
            >
                <CloseIcon className="w-2.5 h-2.5" />
            </button>
            <div>
                <div className="mb-3">
                    <div className="text-base md:text-xl font-medium leading-[1.2] -tracking-[0.4px] text-[#353A3C] dark:text-white">{urlValue ? 'Edit link' : 'Add link'}</div>
                </div>
                <div className="dark:text-white">
                    <div className="space-y-4">
                        <Input value={text} placeholder="Text" label="Text" onChange={setText} />
                        <Input value={url} placeholder="URL" label="URL" onChange={onChangeUrl} isValid={isValidUrl} error={error} />
                    </div>
                </div>
                <div className="flex flex-col-reverse md:flex-row gap-4 md:mt-10 mt-5 pt-5 md:pt-0">
                    <button className="c-btn -lg -no-border-mobile" onClick={(e) => { e.stopPropagation(); setModalOpen(false); }}>Cancel</button>
                    <button className="c-btn -lg -filled-lighter" onClick={handleDoneClick}>Done</button>
                </div>
            </div>
        </ModalBlank>
    );
};
